import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import PrivacyPolicyGames from './components/PrivacyPolicyGames';
import './index.css';

createRoot(document.getElementById('privacy-root')!).render(
  <StrictMode>
    <PrivacyPolicyGames />
  </StrictMode>
);
